import { MessageReference } from 'types/Api'
import { TrackingEventSource } from 'types/TrackingEventSource'

type Input = {
  reference?: MessageReference
  source?: TrackingEventSource
}

export const getTrackingPropsForReferenceEvents = ({ reference, source }: Input) => {
  if (reference?.sourceType === 'karnov_document') {
    return ({
      accessProductKeys: reference?.metadata.accessProductKeys,
      documentId: reference?.metadata.documentId,
      sectionTitle: reference?.metadata.sectionTitle,
      source,
      sourceType: reference.sourceType,
      title: reference?.metadata.title,
      topId: reference?.topId,
    })
  }

  if (reference?.sourceType === 'company_upload') {
    return ({
      areas: reference?.metadata.areas,
      source,
      sourceType: reference.sourceType,
      tags: reference?.metadata.tags,
      title: reference?.metadata.title,
    })
  }

  return {}
}
